// Token Management Module - handles Azure Maps token caching and retrieval
// Shared token cache - Azure Maps tokens are typically valid for 1 hour
const tokenCache = {
    token: null,
    expiresAt: null
};

// Token expiration buffer (5 minutes before actual expiration)
const TOKEN_EXPIRATION_BUFFER = 5 * 60 * 1000; // 5 minutes in milliseconds
// Assume tokens are valid for 1 hour (Azure Maps default)
const TOKEN_VALIDITY_DURATION = 60 * 60 * 1000; // 1 hour in milliseconds

// Helper function to get a valid token (uses cache if available and not expired)
export async function getToken() {
    const now = Date.now();
    
    // Check if we have a valid cached token
    if (tokenCache.token && tokenCache.expiresAt && now < tokenCache.expiresAt) {
        return tokenCache.token;
    }

    // Fetch new token
    const tokenResponse = await fetch('/Map/GetToken');
    if (!tokenResponse.ok) {
        const errorText = await tokenResponse.text();
        throw new Error('Failed to get authentication token: ' + tokenResponse.status + ' - ' + errorText);
    }
    const token = await tokenResponse.text().then(t => t.trim());

    // Cache the token with expiration
    tokenCache.token = token;
    tokenCache.expiresAt = now + TOKEN_VALIDITY_DURATION - TOKEN_EXPIRATION_BUFFER;

    return token;
}

